<template>
  <div class="antialiased">
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
  </div>
</template>